import React from 'react';
import _ from 'lodash';

import { gettext } from '../../i18n/service.js';
import { Button, Modal } from 'react-bootstrap';
import getCurLang from '../../businessLogic/getCurLang.js';

export default class CancelOrderModal extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      showModal:false
    };

    _.bindAll(this, ['close', 'open']);
  }

  close() {
    this.setState({ showModal: false });
  }

  open() {
    this.setState({ showModal: true });
  }

  render() {
    return (
      <div style={{display: 'inline'}}>
        <Button
          bsStyle="danger"
          className="margin_bottom_halfem"
          onClick={this.open}>
          {gettext('CANCEL')}
        </Button>
        <div className="cancelation_modal">
          <Modal bsSize="small" show={this.state.showModal} onHide={this.close} dir={getCurLang()==='ar'?'rtl':'ltr'}>
            <Modal.Body style={{padding: '1em'}}>
              <p>{gettext('CANCEL-ORDER-CONFIRMATION')}</p>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={this.close}>{gettext('NO')}</Button>
              <Button onClick={() => {
                  this.props.cancelOrder(this.props.order);
                  this.close();
                  this.props.closeOrderDetailsModal();
                }}
                bsStyle="danger">{gettext('YES')}</Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/CancelOrderModal.js